import { render, staticRenderFns } from "./introduction.vue?vue&type=template&id=88fc0bc8&scoped=true&"
import script from "./introduction.vue?vue&type=script&lang=js&"
export * from "./introduction.vue?vue&type=script&lang=js&"
import style0 from "./introduction.vue?vue&type=style&index=0&id=88fc0bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fc0bc8",
  null
  
)

export default component.exports